import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = {
  key: 0,
  style: {"list-style":"none","padding":"0","margin":"0"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["onClick"]

import { computed } from 'vue';
import Chip from 'primevue/chip';
import { PersonBuildingInterface } from '@/types/BuildingInterface';
import { PERMISSIONS, EMIT } from '@/enum';
import { can } from '@/composables';

type BuildingInterface = {
  organization_id: number;
  organization_name: string;
  buildings: PersonBuildingInterface[];
};

type organizationInterface = {
  id: number;
  name: string;
  parent_id: number | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BuildingsList',
  props: {
    flattenOrganizations: {},
    buildings: {},
    totalRecords: {},
    loading: { type: Boolean }
  },
  emits: [EMIT.EDIT],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const groupByOrganization = (buildings) => {
  const uniqueOrganizations = [...new Map(props.flattenOrganizations.map((org) => [org.id, org])).values()];

  return uniqueOrganizations.map((org) => {
    const orgBuildings = buildings.filter((b) => b.organization_id === org.id);
    const uniqueBuildings = [...new Map(orgBuildings.map((b) => [b.building_id, b])).values()];

    return {
      organization_id: org.id,
      organization_name: org.name,
      buildings: uniqueBuildings.map((b) => ({
        id: b.id,
        building_id: b.building_id,
        building_name: b.building_name,
        person_id: b.person_id,
      })),
    };
  });
};

const grouped = computed(() => groupByOrganization(props.buildings));

const onEdit = (buildingToEdit: BuildingInterface) => {
  emit(EMIT.EDIT, buildingToEdit);
};

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-xl font-semibold" }, "Buildings", -1)),
        _createVNode(_unref(Chip), null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.totalRecords), 1)
          ]),
          _: 1
        })
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: grouped.value,
        loading: props.loading,
        "data-Key": "organization_id",
        "responsive-layout": "scroll",
        "sort-field": 'organization_name',
        "sort-order": 1
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "organization_name",
            header: "Organization",
            sortable: ""
          }),
          _createVNode(_component_Column, {
            field: "buildings",
            header: "Buildings"
          }, {
            body: _withCtx(({ data }) => [
              (data.buildings.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.buildings, (building) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: building.building_id
                      }, _toDisplayString(building.building_name), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, "Buildings not assigned"))
            ]),
            _: 1
          }),
          (_unref(can)([_unref(PERMISSIONS).BUILDING_ASSIGN]))
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                field: "actions",
                header: "Actions"
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("a", {
                    class: "flex items-center space-x-2",
                    onClick: ($event: any) => (onEdit(data))
                  }, [
                    _createVNode(_component_Icon, {
                      name: "edit",
                      class: "text-lg text-blue-500"
                    }),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-sm text-gray-800" }, "Edit", -1))
                  ], 8, _hoisted_4)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _: 1
  }))
}
}

})